export default "__VITE_ASSET__CCgj650z__"